var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { FormikTextField } from '../atoms/TextField';
import PageSubmitButton from '../molecules/PageSubmitButton';
import { camelize } from '../../utils/camelize';
import { FormikFileField } from '../atoms/FileField';
import DownloadDocumentList from '../atoms/DownloadDocumentList';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 30px 0;\n"], ["\n  margin: 30px 0;\n"])));
var toFormikValue = function (producerBankAccount) {
    return {
        swift_code: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.swiftCode) || '',
        beneficiary_bank_name: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.beneficiaryBankName) || '',
        beneficiary_bank_branch: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.beneficiaryBankBranch) || '',
        beneficiary_bank_address: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.beneficiaryBankAddress) || '',
        account_number: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.accountNumber) || '',
        recipient_company_name: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.recipientCompanyName) || '',
        recipient_name: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.recipientName) || '',
        recipient_address: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.recipientAddress) || '',
        recipient_phone_number: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.recipientPhoneNumber) || '',
        recipient_email_address: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.recipientEmailAddress) || '',
        intermediary_bank_swift_code: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.intermediaryBankSwiftCode) || '',
        intermediary_bank_name: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.intermediaryBankName) || '',
        intermediary_bank_branch: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.intermediaryBankBranch) || '',
        intermediary_bank_address: (producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.intermediaryBankAddress) || '',
    };
};
var REQUIRED_FIELDS = [
    'swift_code',
    'beneficiary_bank_name',
    'beneficiary_bank_branch',
    'beneficiary_bank_address',
    'account_number',
    'recipient_company_name',
    'recipient_name',
    'recipient_address',
];
var ProducerBankAccountForm = function (_a) {
    var producerBankAccount = _a.producerBankAccount, onSubmit = _a.onSubmit, loading = _a.loading;
    var t = useTranslation().t;
    var handleSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var formData;
        return __generator(this, function (_a) {
            formData = new FormData();
            Object.entries(values).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (key == 'documents' &&
                    Array.isArray(value) &&
                    value[0] instanceof File) {
                    value.forEach(function (document) {
                        formData.append("producer_bank_account[".concat(key, "][]"), document);
                    });
                }
                else {
                    formData.append("producer_bank_account[".concat(key, "]"), "".concat(value));
                }
            });
            onSubmit(formData);
            return [2 /*return*/];
        });
    }); }, [onSubmit]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (values[field].trim().length === 0) {
                errors[field] = t('errors.isRequired', {
                    field: t("params.producerBankAccount.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(producerBankAccount),
        onSubmit: handleSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    return (React.createElement(Form, { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 3, style: { marginTop: 5 } },
            [
                'swift_code',
                'beneficiary_bank_name',
                'beneficiary_bank_branch',
                'beneficiary_bank_address',
                'account_number',
                'recipient_company_name',
                'recipient_name',
                'recipient_address',
                'recipient_phone_number',
                'recipient_email_address',
                'intermediary_bank_swift_code',
                'intermediary_bank_name',
                'intermediary_bank_branch',
                'intermediary_bank_address',
            ].map(function (field) { return (React.createElement(Grid, { item: true, xs: 12, key: field },
                React.createElement(FormikTextField, { fullWidth: true, required: REQUIRED_FIELDS.includes(field), name: field, label: t("params.producerBankAccount.".concat(camelize(field))), formik: formik }))); }),
            React.createElement(DownloadDocumentList, { documents: producerBankAccount === null || producerBankAccount === void 0 ? void 0 : producerBankAccount.documents }),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikFileField, { name: "documents", multiple: true, label: t('labels.uploadDocuments'), formik: formik }))),
        React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, !producerBankAccount ? t('buttons.create') : t('buttons.update'))));
};
export default ProducerBankAccountForm;
var templateObject_1;
